export default __webpack_public_path__ + "static/media/r5.471fef16.jpg";